import {
  Button,
  ClickAwayListener,
  IconButton,
  Paper,
  Popper,
  Snackbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const ErrorDialog = (props: { id: string }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(props.id)
      .then(() => {
        setSnackbarOpen(true);
      })
      .catch(() => {});
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <div>
      <Button variant="text" onClick={handleClick} size="small" color="error">
        Show Error
      </Button>
      <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start">
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Paper>
            <Typography sx={{ p: 2 }} className="text-sm">
              Processing for this file failed. Please contact support with this
              id:
              <Typography className="font-bold text-gray-900">
                {props.id}
                <IconButton aria-label="copy" onClick={handleCopyToClipboard}>
                  <ContentCopyIcon />
                </IconButton>
              </Typography>
            </Typography>
          </Paper>
        </ClickAwayListener>
      </Popper>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message="Text copied to clipboard"
      />
    </div>
  );
};

export default ErrorDialog;
